import axios from "axios";
import { useQuery } from "react-query";
import { UserInfo } from "../types/userInfo";

const fetchUserInfo = async (id?: number): Promise<UserInfo> => {
  const LOGIN_API = "https://tmap-react-api.azurewebsites.net/api/user_api_ci?code=wBiEeojG_C-j_3TEmxajVBW5uX6ZNpIK4yTHg1zAyo-WAzFuJSnu2w%3D%3D";
  const { data } = await axios.post(
    LOGIN_API,
    {
      id: id,
    },

    // {
    //   headers: {
    //     "Ocp-Apim-Subscription-Key": process.env.REACT_APP_ML_KEY,
    //   },
    // }
  );

  return data;
};

export function useUserInfo(authKey?: any) {
  return useQuery(["user-info", authKey.id], () => fetchUserInfo(authKey.id), {
    enabled: !!authKey.id,
  });
}
